import { makeStyles } from '@material-ui/core';

import Colors from '../../../../constants/Colors';

export default makeStyles({
  button: {
    padding: '0.5rem',
    fontSize: '0.75rem',
    borderRadius: '0.5rem',
    border: `1px solid ${Colors.TERTIARY_COLOR}`,
    backgroundColor: Colors.GRAY_LIGHT_SHADE,
  },
  buttonStartIconAnimation: {
    animation: '$ripple 2s ease-in-out 0s infinite normal',
  },
  buttonStartIcon: (props: msDropdownBtnProps) => ({
    width: '1.5rem',
    height: '1.5rem',
    marginLeft: '1px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& div': {
      width: '0.75rem',
      height: '0.75rem',
      borderRadius: '50%',
      backgroundColor: props.color,
      boxShadow: `0 0 0.5rem 0.25rem ${props.color}`,
    },
  }),
  buttonEndIcon: (props: msDropdownBtnProps) => ({
    transform: props.open ? 'rotateX(180deg)' : '',
  }),
  drawerPaper: {
    backgroundColor: Colors.WHITE,
  },
  popoverPaper: {
    maxWidth: '24rem',
  },
  drawerCloseBtn: {
    margin: '0 0 1rem',
    padding: '1.125rem',
    fontSize: '1rem',
    lineHeight: 1.25,
    color: Colors.PRINCIPAL_GREY,
  },
  '@keyframes ripple': {
    '0%': {
      width: '0.5rem',
      height: '0.5rem',
      opacity: '80%',
    },
    '50%': {
      width: '0.75rem',
      height: '0.75rem',
      opacity: '100%',
    },
    '100%': {
      width: '0.5rem',
      height: '0.5rem',
      opacity: '80%',
    },
  },
});

interface msDropdownBtnProps {
  open: boolean;
  color: string;
}
